"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var Styled = _interopRequireWildcard(require("./Password.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var PasswordInput = function PasswordInput(_a) {
  var hideText = _a.hideText,
      showText = _a.showText,
      props = (0, _tslib.__rest)(_a, ["hideText", "showText"]);

  var _b = (0, _react.useState)(false),
      showPassword = _b[0],
      setShowPassword = _b[1];

  var type = showPassword ? 'text' : 'password';
  return _react.default.createElement(Styled.PasswordInput, null, _react.default.createElement(Styled.TextInput, (0, _tslib.__assign)({}, props, {
    type: type
  })), _react.default.createElement(Styled.TogglePasswordButton, {
    "data-testid": "passwordToggle",
    type: "button",
    onClick: function onClick() {
      return setShowPassword(!showPassword);
    },
    "aria-labelledby": "eye-description"
  }, showPassword ? _react.default.createElement(Styled.PasswordHiddenIcon, {
    "aria-describedby": "password hidden"
  }) : _react.default.createElement(Styled.PasswordVisibleIcon, {
    "aria-describedby": "password visible"
  }), _react.default.createElement(Styled.PasswordButtonDescription, {
    id: "eye-description"
  }, showPassword ? hideText : showText)));
};

PasswordInput.displayName = 'PasswordInput';
PasswordInput.defaultProps = {
  showText: 'Show password',
  hideText: 'Hide password'
};
var _default = PasswordInput;
exports.default = _default;